import { FuelTypography } from '@frete.com/fuel-react';
import mobile from 'is-mobile';

import { Grid } from '~components';
import { ReactComponent as CreditAnalysis } from '~assets/credit-analysis-mobile.svg';

import * as Styled from '../Credit.styled';

function Approved() {
  const isMobile = mobile();

  return (
    <Styled.Container>
      <Grid container spacing={10} direction="column">
        <Grid className="img-credit-analysis">
          <CreditAnalysis />
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'heading-lg' : 'display-lg'}
            variant="bold"
          >
            Sua empresa possui um limite de crédito pré-aprovado :)
          </FuelTypography>
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'body-sm' : 'body-lg'}
            weight="bold"
            color="neutral-default"
          >
            Conclua a abertura da sua Conta PJ Fretebras para antecipar seus
            recebíveis.
          </FuelTypography>
        </Grid>
      </Grid>
    </Styled.Container>
  );
}

export default Approved;
